import { useMemo } from 'react';
import type { FilterOptionSets } from './components.types';
import { toFilterOptions } from './formatting';
import type { SummaryQualityFilters } from './types';
import { useFilterOptionRows } from './useSummaryQualityQueries';

export const useFilterOptions = ({ from, to, includeBackfilled }: SummaryQualityFilters, enabled = true) => {
  const range = { from, to, includeBackfilled };
  const orgs = useFilterOptionRows(range, 'org', enabled);
  const users = useFilterOptionRows(range, 'user', enabled);
  const models = useFilterOptionRows(range, 'model', enabled);
  const promptHashes = useFilterOptionRows(range, 'prompt_hash', enabled);
  const templates = useFilterOptionRows(range, 'template', enabled);

  const options = useMemo<FilterOptionSets>(
    () => ({
      orgs: toFilterOptions(orgs.data ?? []),
      users: toFilterOptions(users.data ?? []),
      models: toFilterOptions(models.data ?? []),
      promptHashes: toFilterOptions(promptHashes.data ?? []),
      templates: toFilterOptions(templates.data ?? []),
    }),
    [orgs.data, users.data, models.data, promptHashes.data, templates.data]
  );

  const isLoading = [orgs, users, models, promptHashes, templates].some((query) => query.isLoading);
  return { options, isLoading };
};
